var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCardActiveLocal),expression:"isCardActiveLocal"}],ref:"whole_page",attrs:{"id":"iframe-container"}})}
var staticRenderFns = []

export { render, staticRenderFns }